const AppConstant = {
    logo: "LOGO",
    menus: {
        inventory: "Inventory Management",
        bill: "Customer Bills",
        customer: "Customers",
        report: "Dashboards",
        dashboard: "Common",
        salesDashboard: "Sales",
        inventoryDashboard: "Inventory",
        customerDashboard: "Customer",
        vendorDashboard: "Vendors",
        employeeDashboard: "Employees", 
        customDashboard: "Custom",
        customerCreditDashboard: "Customer Credit",
        vendorDebtDashboard: "Vendor Debt",
        cycle: "Cycle Count",
        vendor: "Vendor",
        vendorPurchase: "Vendor Bills",
        employee: "Employee",
        attendance: "Attendance",
        procurement: "Procurement",
        salesReturn: "Sales Return",
        mugizhAdmin: "Mugizh Admin",
        stock: "Stock",
        topPicks: "Top Picks",
        hotNew: "Hot New",
        category: "Category",
        banners: "Banners",
        onlineBilling: "Online Billing",
        auditLog: "Audit Log",
        festival: "Festival",
        feedbackDashboard: "Feedback",
        feedbackList: " Feedback",
        rental: "Rental"
    },
    // Fixed sentinel values, not backed by the reference/referenceGroup lookup
    // table — Work Type only ever has these two options, so it doesn't need
    // a DB-seeded reference group. These ids are stored directly in
    // tbl_employee.workTypeRefId and resolved by a static CASE in
    // AttendanceService (no join to `reference`).
    workTypeOptions: [
        { id: 1, name: "Full Time" },
        { id: 2, name: "Part Time" }
    ],
    // Same rationale as workTypeOptions — Attendance Status only ever has
    // these 4 fixed values, stored directly in tbl_attendance.statusRefId and
    // resolved by a static CASE in AttendanceService (no join to `reference`).
    attendanceStatusOptions: [
        { id: 1, name: "Present" },
        { id: 2, name: "Absent" },
        { id: 3, name: "Half Day" },
        { id: 4, name: "Leave" }
    ],
    menuHeader: {
        inventory: 'Inventory',
        orders: 'Bills',
        users: 'Users',
        admin: 'Admin',
        reports: 'Reports',
        feedback: 'Feedback'
    },
    printSticker: "Print Sticker",
    add: "+Add",
    goToPage: "Go to page",
    completedSticker: "Stickering Completed",
    damaged: "Damaged",
    inStock: "In Stock",
    outOfStock: "Out Of Stock",
    returned: "Returned",
    scrap: "Scrap",
    history: "History",
    createBill: "Create Bill",
    editBill: "Edit Bill",
    billType: "Bill Type",
    mobile: "Mobile Number",
    customerName: "Customer Name",
    cycleCountName: "Name",
    paymentMethod: "Payment Method",
    items: "Items",
    discount: "Discount",
    itemCountText: "Total No of Item Count",
    amount: "Amount",
    GST: "GST",
    totalAmount: "Total Amount",
    cancel: "Cancel",
    save: "Save",
    ok: "ok",
    view: "View",
    addCustomer: "Add Customer",
    editCustomer: "Edit Customer",
    createCycleCount: 'Create Cycle Count',
    name: "Name",
    create: "Create",
    somethingWentWrong: "Something went wrong please contact administor",
    // Matches apparel-api's AppConstants.CREATED_SUCCESSFULLY exactly — createBilling_v2
    // returns this bare string on success and an error string (e.g. "Invalid id",
    // "Mobile Number Already Exist") on failure, so this is the only way to tell them apart.
    billingSavedSuccessfully: "Created Successfully",
    login: "Login",
    emailId: "Email ID",
    password: "Password",
    forgotPassword: "Forgotten Password?",
    sendOtp: "Send OTP",
    verifyOtp: "Verify & Login",
    resendOtp: "Resend OTP",
    changeEmail: "Change email",
    otpSentTo: "Enter the 6-digit code sent to",
    otpLabel: "OTP",
    otpExpired: "OTP expired. Please resend.",
    invalidOtp: "Invalid or expired OTP",
    OTP_VALIDITY_SECONDS: 300,
    purchaseHistory: "Purchase History",
    SECRET_KEY: "d#@%[q*=)r3v0Lit3sEcRet(=$@-!+#b",
    soldItems: "Sold Items",
    returnedItems: "Returned Items",
    categories: "Categories",
    subCategory: "Sub Category",
    count: "Count",
    totalBillAmount: "Total Bill Amount",
    viewBilling: "View Billing",
    barcodeNumber: "Barcode Number",
    productName: "Product Name",
    quantity: "Quantity",
    totalPrice: "Total Price",
    productId: "Product ID",
    available: "Available",
    sold: "Sold",
    missed: "Missed",
    returnedToVendor: "Returned To Vendor",
    downloadSticker: "Download Sticker",
    edit: "Edit",
    zero: 0,
    one: 1,
    two: 2,
    PLEASE_COMPLETE_THE_PENDING_CYCLECOUNT: "Please Complete the pending cycleCount",
    PENDING: "PENDING",
    COMPLETED: "COMPLETED",
    SALES_REPORT: "Sales Report",
    PRODUCT_REPORT: "Product Report",
    PURCHASE_REPORT: "Purchase Report",
    Active: "Active",
    InActive: "InActive",
    Delete: "Delete",
    FIVE: 5,
    HOTNEW: 'Hot New',
    TOPPICK: 'Top Pick',
    NAME_ALREADY_EXISTS: 'NAME ALREADY EXISTS',
    PRODUCT_IS_PRESENT: "PRODUCT IS PRESENT",
    NEWORDERS: "New Orders",
    INTRANSIT: "In Transit",
    DELIVERED: "Delivered",
    CANCELLED: "Cancelled",
    PAYMENT_SUCCESS:"Payment Success",
    PAYMENT_FAILURE:"Payment Faliure",
}

export default AppConstant;